import { render, staticRenderFns } from "./AppliedRecord.vue?vue&type=template&id=7b9b2150&scoped=true&"
import script from "./AppliedRecord.vue?vue&type=script&lang=js&"
export * from "./AppliedRecord.vue?vue&type=script&lang=js&"
import style0 from "./AppliedRecord.vue?vue&type=style&index=0&id=7b9b2150&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9b2150",
  null
  
)

export default component.exports